.tree-select-checkbox-container .checkbox-label {
  color: var(--uui-gray-01);
  font-family: "Helvetica Now Text";
}

.tree-select-checkbox-container p {
  --uui-p-default-margin-bottom: 0;
}

.tree-select-checkbox-container .ellipsis-text {
  max-width: var(--uui-tree-select-item-max-width);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
